import { render, staticRenderFns } from "./ConsultaContabilizacion.vue?vue&type=template&id=1796d141"
import script from "./ConsultaContabilizacion.vue?vue&type=script&lang=js"
export * from "./ConsultaContabilizacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports